import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'genderPipe'
})
export class GenderPipe implements PipeTransform {
  transform(gender: string) {
    const p = (gender || '').trim().toLowerCase();
    return p === 'm' ? 'Male' : p === 'f' ? 'Female' : 'Invalid Gender';
  }
}
